import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import { RemoveShipmentModal } from './remove-shipment-modal';
import { useCanUnlink } from '../../../../../../../fulfillment-plans/unlink-button/hooks';
import { useFulfillmentPlanIdContext } from '../../../../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import { useModal } from '../../../../../../../hooks/use-modal';
import { useSalesOrderIdContext } from '../../../../../../context/sales-order-id-context-provider';

import messages from '../../messages';
import style from '../../shipment-items.module.less';

export const RemoveShipmentButton = () => {
  const fulfillmentPlanId = useFulfillmentPlanIdContext();
  const salesOrderId = useSalesOrderIdContext();
  const canUnlink = useCanUnlink(fulfillmentPlanId, salesOrderId);
  const { open, close, isOpen } = useModal();

  if (!canUnlink) {
    return null;
  }

  return (
    <>
      <Button onClick={open} theme='link'>
        <FormattedMessage {...messages.removeShipmentButton} />
      </Button>
      <div className={style.divider} />
      {isOpen && <RemoveShipmentModal onClose={close} />}
    </>
  );
};
